import { TableUserListType, ApiUserType, PendingMembership } from './types';
import { getFormattedDate } from '../../helpers/date';

type ApiRole = { id: string; name?: string; type?: string };

type MembershipClient = {
  getPromise: (path: string) => Promise<any>;
  postPromise: (path: string, data: {}) => Promise<any>;
  patchPromise: (path: string, data: {}) => Promise<any>;
};

// Grants every selected membership through the generic POST /members (same
// path that syncs chat & automation). Returns the number of failed grants.
export const grantMemberships = async (
  client: MembershipClient,
  userId: string,
  memberships: PendingMembership[]
): Promise<number> => {
  const rolesResp: { data?: ApiRole[] } = await client.getPromise('/roles');
  const allRoles = rolesResp?.data ?? [];

  const results = await Promise.allSettled(
    memberships.map(membership => {
      const role = allRoles.find(
        r => r.name === membership.roleKind && r.type === membership.modelType
      );
      if (!role) return Promise.reject(new Error('role not found'));

      return client
        .postPromise('/members', {
          source: { id: userId, model_type: 'user' },
          target: { id: membership.targetId, model_type: membership.modelType },
          roles: [{ id: role.id }],
        })
        .then(created => {
          // Le rôle admin de groupe emporte aussi le grant de publication
          // par adhésion (community manager).
          if (
            membership.modelType === 'group' &&
            membership.roleKind === 'administrator'
          ) {
            return client
              .patchPromise(
                `/groups/${membership.targetId}/members/${userId}/publish`,
                { can_publish: true }
              )
              .catch(() => created);
          }
          return created;
        });
    })
  );

  return results.filter(r => r.status === 'rejected').length;
};

export const filterApiResponse = (data: ApiUserType[]): TableUserListType => {
  return data.map(user => {
    return {
      key: user.id,
      id: user.id,
      user: {
        id: user.id,
        name: user.name,
        email: user?.primary_email?.email,
        places: user?.places?.[0]?.address?.formatted_address,
        roles: user?.roles,
        createdAt: getFormattedDate(user.created_at, 'DD/MM/YYYY'),
        avatarUrl: user?.avatar?.url?.small ?? user?.avatar?.url?.original,
      },
    };
  });
};
